"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const i=require("@mui/material"),t=require("@mui/material/styles"),l=require("./appointment-schedule.constants.js"),d=t.styled(i.Paper,{shouldForwardProp:e=>e!=="isExtended"})(({theme:e})=>`
  display: flex;
  overflow: auto;
  flex-direction: column;
  align-items: flex-start;
  background-color: ${e.palette.common.white};
  border-radius: 0;
  width: 100%;
  scrollbar-width: none;
  -ms-overflow-style: none;
 
  ::-webkit-scrollbar {
    display: none;
  }
 `),a=t.styled("div",{shouldForwardProp:e=>e!=="isExtended"})(()=>`
  display: flex;
  position: relative;
  z-index: 4;
  width: 100%;
`),n=t.styled("div",{shouldForwardProp:e=>e!=="isExtended"})(()=>`
  display: flex;
  height: 100%;
  min-width: 100%;
`),p=t.styled("div",{shouldForwardProp:e=>e!=="isActive"&&e!=="width"})(({theme:e,isActive:r,width:o})=>`
  background: ${r?e.palette.primary[75]:e.palette.common.white};
  text-align: center;
  height: 40px;
  min-width: 80px;
  width: ${o?`${o}%`:"100%"};
  padding: 0 4px;
  box-sizing: border-box;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${e.palette.primary[900]};
  flex-shrink: 0;
  border: 1px solid ${r?e.palette.primary[75]:e.palette.grey[300]};
 `),s=t.styled("div",{shouldForwardProp:e=>e!=="isExtended"&&e!=="width"})(({theme:e,width:r})=>`
  width: ${r?`${r}%`:`${l.COLUMN_WIDTH}px`};
  height: 56px;
  margin: 0;
  padding: 8px 4px;
  box-sizing: border-box;
  background: ${e.palette.common.white};
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  text-align: center;
  flex-shrink: 0;
  flex-grow: 0;
  outline: 1px solid ${e.palette.grey[300]};
  position: relative;
  z-index: 3;
  overflow: hidden;
 `),c=t.styled("div",{shouldForwardProp:e=>e!=="isDayView"})(({theme:e,isDayView:r})=>`
  display: flex;
  background: ${e.palette.common.white};
  min-width: ${r?"100%":"initial"};
 `),h=t.styled("div",{shouldForwardProp:e=>e!=="width"&&e!=="minWidth"&&e!=="isContentWrapper"})(({width:e,minWidth:r,isContentWrapper:o})=>`
  width: ${e}%;
  min-width: ${r?`${r}px`:"initial"};
  display: ${o?"flex":"block"};
`),y=t.styled("div")(({theme:e})=>({display:"flex",justifyContent:"center",alignItems:"center",overflow:"hidden",flexShrink:0,flexGrow:0,whiteSpace:"nowrap",textOverflow:"ellipsis",color:e.palette.grey[800]})),x=t.styled(i.Typography)(({theme:e})=>({maxWidth:"120px",marginLeft:"8px",color:e.palette.grey[800]})),u=t.styled(i.Typography,{shouldForwardProp:e=>e!=="isExtended"})(({theme:e,isExtended:r})=>`
  color: ${e.palette.grey[700]};
  marginTop: ${r?6:0}px;
 `),m=t.styled("div")`
  display: flex;
  width: 100%;
  position: relative;
`,w=t.styled("div")`
  height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
`,g=t.styled(i.Paper,{shouldForwardProp:e=>e!=="offset"})(({theme:e,offset:r})=>`
    width: 49px;
    flex-shrink: 0;
    text-align: center;
    border-radius: 8px 0 0 8px;
    background: ${e.palette.common.white};
    overflow: hidden;
    padding-top: ${r??0}px;
 `);exports.AvatarWrapper=y;exports.EmployeeName=x;exports.EmployeeWorkingTimes=u;exports.InnerWrapper=m;exports.ScheduleContentWrapper=n;exports.ScheduleDayHeader=p;exports.ScheduleDayWrapper=h;exports.ScheduleEmployeeHeader=s;exports.ScheduleEmployeesWrapper=c;exports.ScheduleHeaderWrapper=a;exports.ScheduleWrapper=d;exports.TimelineWrapper=g;exports.Wrapper=w;
